<script>
    import PageSection from "../../components/PageSection.svelte";
    import LandingPage from "./LandingPage.svelte";
    import PersonalDetails from "./PersonalDetails.svelte";
    import ClaimDetails from "./ClaimDetails.svelte";
    import NavigationButtons from "../../components/NavigationButtons.svelte";
    import Checkbox from '../../components/Checkbox.svelte';
    import FormRow from '../../components/FormRow.svelte';
    import FormColumn from '../../components/FormColumn.svelte';

    import { trackSubmit } from "../../analytics";
    import { pageNumber, model } from "../../stores";
    import { projectSettings } from "../../config";

    export let pageIndex = null;
    export let pageTitle = null;
    export let nextPage = null;
    export let nextPageLabel = null;
    export let previousPage = null;
    export let persistUrl = null;
    export let lastVisitedPage = null;

    let disabled = "true";

    if ($pageNumber == pageIndex + 1) {
        alert("Your registration has already been submitted.");
        window.location.href = window.basePath;
    } else {
        $pageNumber = pageIndex;
    }

    $model.LastPageVisited = lastVisitedPage;
    document.title = pageTitle;

    const onSubmit = () => {
        trackSubmit(projectSettings.classActionName);
    };

    let confirmed = false;
</script>

{#if ($pageNumber == pageIndex)}
<PageSection>
	<div class="confirmation">
         <FormRow class="justify-content-center">
            <FormColumn>
                <h1 class="text-center">{@html projectSettings.classActionName}</h1>
                <h2 class="text-center">Please confirm your details below to complete your registration</h2>
                <p>
                    Please review the information you have provided and confirm the
                    information is true and correct by clicking the checkbox below.
                </p>
                <p>
                    If you need to edit any of your answers, please do so by clicking the 'Previous' button at the bottom of the page.
                </p>
            </FormColumn>
        </FormRow>

        <LandingPage {disabled}></LandingPage>
        <PersonalDetails {disabled}></PersonalDetails>
        <ClaimDetails {disabled}></ClaimDetails>

        <FormRow>
            <FormColumn cols="8" class="col-sm-12">
                <Checkbox required="true" bind:checked="{confirmed}" label="I confirm that all information provided in this section is true and correct." id="confirmation"></Checkbox>
            </FormColumn>
        </FormRow>

        <FormRow class="mt-4">
            <FormColumn class="last">
                <NavigationButtons {persistUrl}
                                   {previousPage}
                                   {nextPage}
                                   {nextPageLabel}
                                   disableNext={!confirmed}
                                   {onSubmit}></NavigationButtons>
            </FormColumn>
        </FormRow>
    </div>

</PageSection>
{/if}

<style>

    :global(.confirmation .confirmation-hide) {
        display: none;
    }

    :global(.confirmation-show) {
        display: none;
    }

    :global(.confirmation .confirmation-show) {
        display: flex;
    }

    :global(.confirmation .confirmation-show h1,
            .confirmation .confirmation-show h2) {
        margin-bottom: 16px;
    }

    :global(.confirmation .confirmation-box-shadow) {
        border: 1px solid var(--color-soft);
        background-color: var(--color-white);
        box-shadow: var(--box-shadow-card);
        padding: 20px;
        margin-bottom: 26px;
    }
 
    :global(.confirmation input.form-control,
            .confirmation select.form-control) {
        border: 1px solid var(--color-soft);
        background-color: var(--color-white);
        height: 44px;
        line-height: 18px;
        background-image: none;
    }
 
    :global(.confirmation textarea.form-control) {
        border: 1px solid var(--color-soft);
        background-color: var(--color-white);
        background-image: none;
    }
 
    :global(.confirmation .row) {
        margin-top: 16px;
    }
  
    :global(.confirmation .datepicker .calendar-icon) {
        display: none;
    }

    
	:global(.confirmation h2) {
        margin-bottom: 0 !important;
        margin-top: 16px;
    }

</style>

